/* The property strategy tool (Stage 1, docs/property-strategy-spec.md). Made from the frozen prototype's styles.css
   (0.28) by scoping every rule under .pst, the tool's root (screens/PropertyStrategy.jsx; .ps is POYT Start Here's),
   so nothing here reaches another hub page: :root's tokens and body's background, ink and font are on .pst; * is
   .pst *; html's scroll padding applies only while the tool is on the page (html:has(.pst)); the keyframes carry a
   pst- prefix. The declarations are the prototype's: the approved graphite and lime design (Adam's decision 4, 27 Oct
   2026). Inside a product, the product's own look fills the screen (CLAUDE.md, Look and copy). The tool's own blocks
   at the end: the full-height root, the hub's global rules undone inside the tool, and printing without the hub. */
/* Instrument Sans as three faces: static 400 and 700 files (Chrome embeds these as real fonts when it prints a PDF)
and the variable file for 500 and 600. The in-app PDF uses these too, so it prints like the downloaded copy. */
@font-face{font-family:'Instrument Sans';src:url('./assets/instrument-sans-regular.ttf') format('truetype');font-style:normal;font-weight:400;font-display:swap}
@font-face{font-family:'Instrument Sans';src:url('./assets/instrument-sans.woff2') format('woff2');font-style:normal;font-weight:500 600;font-display:swap}
@font-face{font-family:'Instrument Sans';src:url('./assets/instrument-sans-bold.ttf') format('truetype');font-style:normal;font-weight:700;font-display:swap}
.pst{--ink:#242820;--paper:#f4f5ef;--surface:#fff;--muted:#686d61;--line:#dce0d5;--accent:#cbea52;--accent-deep:#425711;--soft:#edf1e5;--font:'Instrument Sans',Arial,sans-serif}
.pst *{box-sizing:border-box}
html:has(.pst){scroll-behavior:auto;scroll-padding-top:90px}
.pst{margin:0;background:var(--paper);color:var(--ink);font:16px/1.5 var(--font);-webkit-font-smoothing:antialiased}
.pst button,.pst input,.pst select,.pst textarea{font:inherit}
.pst button,.pst a,.pst summary{touch-action:manipulation}
.pst button{cursor:pointer;color:inherit}
.pst a{color:inherit}
.pst button:focus-visible,.pst a:focus-visible,.pst input:focus-visible,.pst select:focus-visible,.pst textarea:focus-visible,.pst summary:focus-visible{outline:3px solid #657f21;outline-offset:4px}
.pst button:disabled{opacity:.5;cursor:default}
.pst h1,.pst h2,.pst h3,.pst h4,.pst p,.pst figure{margin:0}
.pst h1,.pst h2,.pst h3,.pst h4{font-weight:600;line-height:1.12;letter-spacing:-.045em}
.pst h1{font-size:clamp(36px,4.3vw,64px)}
.pst h2{font-size:26px}
.pst h3{font-size:21px}
.pst p{overflow-wrap:break-word}
.pst button{border:0}
.pst fieldset{border:0;padding:0;margin:0;min-width:0}
.pst legend{padding:0;max-width:100%}
.pst input,.pst textarea,.pst select{color:var(--ink)}
.pst .sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}
.pst .skip{position:fixed;top:-100px;left:16px;background:var(--ink);color:white;padding:12px 16px;z-index:100}
.pst .skip:focus{top:12px}
.pst .eyebrow{font-size:10px;line-height:1.4;font-weight:600;letter-spacing:.13em;text-transform:uppercase}
.pst .fine{font-size:12px;line-height:1.5;color:var(--muted)}
.pst .muted{color:var(--muted)}
.pst .small-label{font-size:12px;background:var(--soft);padding:6px 10px;border-radius:4px}
.pst .text-button,.pst .link{display:inline-flex;align-items:center;justify-content:space-between;gap:18px;padding:10px 0;background:none;text-decoration:none;font-size:13px;font-weight:600;text-align:left}
.pst .text-button:hover,.pst .link:hover{text-decoration:underline;text-underline-offset:4px}
.pst .text-button span,.pst .btn span{font-size:20px;line-height:1;font-weight:400}
.pst .btn{display:inline-flex;justify-content:space-between;align-items:center;gap:30px;min-height:54px;padding:16px 22px;background:var(--accent);color:#242820;border:1px solid transparent;border-radius:7px;font-size:14px;line-height:1.3;font-weight:600;text-decoration:none;transition:background .15s,transform .15s}
.pst .btn:hover{background:#d7f565;transform:translateY(-1px)}
.pst .btn.secondary{background:transparent;border-color:var(--line)}
.pst .btn.secondary:hover{background:var(--soft)}
/* The application frame */
.pst .product-shell{display:grid;grid-template-columns:224px minmax(0,1fr);min-height:100svh}
.pst .workspace-side{position:sticky;top:0;height:100svh;display:flex;flex-direction:column;padding:34px 24px 22px;background:#fafbf7;border-right:1px solid var(--line)}
.pst .brand{display:flex;align-items:center;gap:10px;font-size:23px;font-weight:600;line-height:.95;letter-spacing:-1px;text-decoration:none;width:max-content}
.pst .brand-second{display:block}
.pst .brand-dot{color:#607928}
.pst .brand-mark{width:32px;height:35px;position:relative;display:block;margin-right:2px}
.pst .brand-mark i{position:absolute;display:block;width:22px;height:10px;border:1.5px solid var(--ink);transform:skewY(-22deg);left:3px}
.pst .brand-mark i:nth-child(1){top:3px;background:var(--accent)}
.pst .brand-mark i:nth-child(2){top:13px}
.pst .brand-mark i:nth-child(3){top:23px}
.pst .side-section-label{font-size:9px;font-weight:600;letter-spacing:.14em;color:var(--muted);margin:64px 0 22px}
.pst .workspace-stages{list-style:none;padding:0;margin:0}
.pst .workspace-stages li{display:flex;gap:12px;position:relative;padding-bottom:36px;color:var(--muted)}
.pst .workspace-stages li:not(:last-child):before{content:'';position:absolute;top:30px;left:14px;width:1px;bottom:4px;background:var(--line)}
.pst .stage-node{display:grid;place-items:center;width:29px;height:29px;flex:0 0 29px;border:1px solid var(--line);border-radius:50%;font-size:10px;line-height:1;background:#fafbf7}
.pst .workspace-stages strong{display:block;font-size:13px;font-weight:500;padding-top:4px;color:var(--ink)}
.pst .workspace-stages small{display:block;font-size:10px;line-height:1.5;margin-top:5px;max-width:108px}
.pst .workspace-stages .active .stage-node{background:var(--ink);border-color:var(--ink);color:var(--accent)}
.pst .workspace-stages .active strong{font-weight:700}
.pst .workspace-stages .complete .stage-node{background:var(--accent);border-color:var(--accent);color:var(--ink)}
.pst .side-bottom{margin-top:auto}
.pst .author{display:flex;align-items:center;gap:10px}
.pst .author img{object-fit:contain;width:50px;height:60px}
.pst .author span{font-size:11px;font-weight:600;display:block}
.pst .author small{font-size:9px;color:var(--muted);display:block;margin-top:3px}
.pst .side-bottom>p{border-top:1px solid var(--line);margin-top:18px;padding-top:16px;font-size:10px;color:var(--muted)}
.pst .workspace-main{min-width:0}
.pst .workspace-top{height:80px;border-bottom:1px solid var(--line);padding:0 42px;display:flex;align-items:center;justify-content:space-between;gap:16px}
.pst .workspace-location{font-size:12px;color:var(--muted)}
.pst .top-tools{display:flex;gap:20px;align-items:center}
.pst .tool-button{background:none;font-size:12px;padding:12px 0;min-height:44px}
.pst .tool-button:hover{text-decoration:underline;text-underline-offset:3px}
.pst .free-label{font-size:11px;display:flex;gap:7px;align-items:center}
.pst .free-label:before{content:'';width:6px;height:6px;background:#6c832c;border-radius:50%}
.pst .info-button{border:1px solid #c9cec0;width:26px;height:26px;min-width:26px;border-radius:50%;background:none;font-size:12px;font-family:Georgia,serif;font-style:italic}
.pst .info-button:before{content:'';position:absolute;inset:-9px}
.pst .info-button{position:relative}
.pst .preview-button{color:#546426}
.pst .mobile-brand,.pst .mobile-report-nav{display:none}
.pst .wrap{width:100%;max-width:1280px;padding:40px 42px 24px;margin:0 auto}
.pst .product-footer{display:flex;justify-content:space-between;gap:16px;padding:12px 42px 24px;font-size:10px;color:var(--muted);max-width:1280px;margin:auto}
.pst .product-footer>span{align-self:center}
.pst .product-footer .text-button{font-size:10px;font-weight:400}
.pst .product-footer .text-button span{font-size:14px}
.pst .example{padding:8px 42px;background:#edf2df;font-size:10px;color:#52632c;display:flex;gap:14px}
.pst .example>span{font-size:9px;letter-spacing:.08em;font-weight:700}
.pst .workspace-nav{display:flex;flex-direction:column;gap:6px;margin:0 -10px}
.pst .workspace-nav button{display:flex;align-items:center;gap:12px;border-radius:6px;padding:15px 10px;background:none;text-align:left;font-size:13px;color:var(--muted)}
.pst .nav-number{font-size:9px;letter-spacing:.05em}
.pst .nav-arrow{margin-left:auto;font-size:18px;opacity:0}
.pst .workspace-nav button[aria-current=page]{background:var(--ink);color:#fff}
.pst .workspace-nav button[aria-current=page] .nav-number,.pst .workspace-nav button[aria-current=page] .nav-arrow{color:var(--accent);opacity:1}
.pst .workspace-nav button:hover:not([aria-current]){background:var(--soft)}
/* Start: one promise, one action, one visual explanation */
.pst .intro-wrap{padding-top:40px}
.pst .start-canvas{display:grid;grid-template-columns:minmax(0,1.12fr) minmax(0,.88fr);gap:36px;background:white;border:1px solid #e5e8de;border-radius:16px;padding:46px;min-height:530px}
.pst .start-copy{display:flex;flex-direction:column;align-items:flex-start;justify-content:center}
.pst .start-copy>.eyebrow{font-size:9px;display:flex;align-items:center;gap:8px;margin-bottom:29px}
.pst .live-dot{width:6px;height:6px;border-radius:50%;background:#68842a;display:inline-block}
.pst .start-copy h1{font-size:clamp(48px,5.3vw,82px);font-weight:500;line-height:.99;letter-spacing:-.065em}
.pst .start-copy h1>span{color:#7a8270}
.pst .start-lede{font-size:16px;line-height:1.55;max-width:320px;margin-top:24px;color:#60665a}
.pst .start-action{margin-top:32px;width:100%;max-width:300px}
.pst .start-action .btn{width:100%}
.pst .start-action>p{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:12px;font-size:10px;color:var(--muted)}
.pst .plan-preview{background:#272c23;color:#f4f6ed;border-radius:11px;padding:27px 25px;display:flex;flex-direction:column;justify-content:space-between;align-self:stretch;position:relative;overflow:hidden;min-height:410px}
.pst .plan-preview-top{display:flex;justify-content:space-between;align-items:center;font-size:9px;letter-spacing:.16em}
.pst .plan-preview-top>span:last-child{font-size:24px;color:var(--accent)}
.pst .preview-route{padding:35px 0 24px}
.pst .preview-route-item{display:flex;gap:17px;position:relative;padding-bottom:31px}
.pst .preview-route-item:last-child{padding-bottom:0}
.pst .preview-route-item:not(:last-child):before{content:'';position:absolute;left:15px;top:33px;bottom:0;width:1px;background:#606952}
.pst .route-point{display:grid;place-items:center;border:1px solid #7b896a;width:31px;height:31px;flex:0 0 31px;color:var(--accent);border-radius:50%;font-size:10px;background:#272c23}
.pst .preview-route-item:first-child .route-point{background:var(--accent);border-color:var(--accent);color:var(--ink)}
.pst .preview-route-item small{font-size:8px;line-height:1.2;letter-spacing:.1em;color:#acb59f}
.pst .preview-route-item h2{font-size:24px;margin:7px 0 8px;letter-spacing:-.04em}
.pst .preview-route-item p{font-size:11px;line-height:1.5;color:#c2c9b8;max-width:185px}
.pst .preview-signature{display:flex;justify-content:space-between;align-items:center;border-top:1px solid #4b5541;padding-top:17px;font-size:8px;letter-spacing:.13em;color:#b9c5a8}
.pst .signature-mark{font-size:35px;color:var(--accent)}
.pst .start-note{display:flex;align-items:center;justify-content:space-between;gap:20px;padding:20px 1px;font-size:12px;color:var(--muted)}
.pst .start-note .text-button{font-size:11px;white-space:nowrap}
.pst .resume-review{margin-top:-8px}
/* Question: the decision occupies the screen */
.pst .question-wrap{max-width:790px;padding-top:48px;padding-bottom:22px}
.pst .question-meta{display:flex;justify-content:space-between;gap:20px;font-size:11px;color:var(--muted);margin-bottom:15px}
.pst .question-progress{height:3px;background:#dfe4d6;margin-bottom:36px}
.pst .question-progress span{display:block;height:100%;background:#6b802f;transition:width .25s}
.pst .question{font-size:clamp(28px,3.1vw,40px);line-height:1.13;letter-spacing:-.045em;max-width:660px}
.pst .hint{color:var(--muted);font-size:13px;line-height:1.55;margin:16px 0 27px;max-width:630px}
.pst .option{display:flex;align-items:center;gap:15px;position:relative;background:#fff;border:1px solid #dce0d5;border-radius:7px;padding:17px 18px;min-height:60px;margin-bottom:10px;cursor:pointer;transition:border-color .15s,background .15s,box-shadow .15s}
.pst .option:hover{border-color:#9aa68a;background:#fafcf6}
.pst .option.selected{border-color:#5c732c;background:#eff5df;box-shadow:0 0 0 1px #5c732c}
.pst .option:has(input:focus-visible){outline:3px solid #657f21;outline-offset:3px}
.pst .option input{position:absolute;opacity:0;width:1px;height:1px}
.pst .option-index{font-size:10px;font-variant-numeric:tabular-nums;color:#777e6e}
.pst .option-label{font-size:14px;line-height:1.5;flex:1}
.pst .option-indicator{width:18px;height:18px;border-radius:50%;border:1px solid #bac3ae;flex:0 0 18px;background:#fff}
.pst .option:has(input[type=checkbox]) .option-indicator{border-radius:4px}
.pst .selected .option-indicator{background:#4c6226;border-color:#4c6226;position:relative}
.pst .selected .option-indicator:after{content:'';position:absolute;left:5px;top:3px;width:5px;height:8px;border-right:1.5px solid #fff;border-bottom:1.5px solid #fff;transform:rotate(45deg)}
.pst .question-actions{display:flex;align-items:center;justify-content:space-between;gap:24px;position:sticky;bottom:0;padding:23px 0 18px;background:var(--paper);border-top:1px solid var(--line);margin-top:28px;z-index:3}
.pst .question-actions .btn{min-width:182px}
.pst .question-why{font-size:11px;color:var(--muted);margin-top:8px}
.pst .question-why summary{font-weight:400}
.pst .question-why p{margin-top:12px}
.pst .error:empty{display:none}
.pst .error{padding:16px 20px;background:#fff0e9;border:1px solid #bc7457;margin-bottom:24px;font-size:13px}
.pst .error h2{font-size:18px;margin-bottom:8px}
.pst .error a{color:#713720}
.pst .amount{display:flex;align-items:center;margin:20px 0;gap:12px;font-size:25px;font-weight:600}
.pst .amount input{width:100%;max-width:300px;padding:15px 16px;border:1px solid #9ea992;background:#fff;border-radius:6px;font-size:22px}
.pst .text-input{width:100%;min-height:120px;padding:18px;border:1px solid var(--line);border-radius:7px;background:#fff}
.pst .scenario,.pst .comparison{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:24px}
.pst .scenario-card,.pst .comparison>div{background:white;border:1px solid var(--line);padding:20px;border-radius:7px}
.pst .scenario h2,.pst .comparison h2{font-size:20px;margin-bottom:16px}
.pst .scenario p,.pst .comparison p{font-size:13px;margin-top:12px}
.pst .scenario strong{font-weight:600}
/* Answer review */
.pst .view-heading{margin:0 0 34px;max-width:850px}
.pst .view-heading>.eyebrow{color:var(--muted);margin-bottom:20px}
.pst .view-heading .eyebrow>span{color:#89917f;margin-left:7px}
.pst .view-heading>p:last-child{font-size:15px;color:var(--muted);line-height:1.6;max-width:580px;margin-top:18px}
.pst .review-wrap{max-width:1000px}
.pst .review-ready{display:flex;align-items:center;justify-content:space-between;gap:24px;padding:24px;background:#fff;border:1px solid var(--line);border-radius:10px;margin-bottom:26px}
.pst .review-ready>div{display:flex;align-items:center;gap:16px}
.pst .review-ready p{font-size:14px}
.pst .ready-symbol{width:35px;height:35px;display:grid;place-items:center;border-radius:50%;background:var(--soft);color:#4b6225}
.pst .answer-group{border-bottom:1px solid var(--line)}
.pst .answer-group>summary{display:flex;justify-content:space-between;align-items:center;gap:20px;padding:24px 0;cursor:pointer;font-size:15px}
.pst .answer-group>summary>span:last-child{font-size:11px;color:var(--muted);display:flex;align-items:center;gap:28px}
.pst .answer-group>summary>span:last-child>span{font-size:22px;font-weight:400}
.pst .answer-group[open]>summary>span:last-child>span{transform:rotate(45deg)}
.pst .answer-group dl{margin:0 0 24px;padding:0 24px;background:#fff;border-radius:8px}
.pst .summary-row{display:grid;grid-template-columns:1fr auto;column-gap:24px;padding:22px 0;border-bottom:1px solid var(--line)}
.pst .summary-row:last-child{border:0}
.pst .summary-row dt{grid-column:1;font-size:12px;color:var(--muted)}
.pst .summary-row dd{grid-column:1;margin:8px 0 0;font-size:14px}
.pst .summary-row button{grid-column:2;grid-row:1 / span 2;align-self:start}
/* Personal plan */
.pst .result-wrap{max-width:1230px}
.pst .overview-grid{display:grid;grid-template-columns:minmax(0,1.15fr) minmax(0,.85fr);gap:22px}
.pst .strategy-answer{position:relative;min-height:340px;display:flex;flex-direction:column;background:#fff;border:1px solid #e3e6db;border-radius:13px;padding:32px;overflow:hidden}
.pst .strategy-answer>.eyebrow{color:var(--muted);margin-bottom:27px}
.pst .strategy-answer h1{font-size:clamp(37px,4.4vw,65px);font-weight:500;line-height:1;letter-spacing:-.06em}
.pst .strategy-answer h1.short-name{font-size:clamp(70px,7.5vw,105px);letter-spacing:-.07em}
.pst .strategy-subtitle{font-size:14px;margin-top:16px;line-height:1.5;max-width:390px;color:#626a58}
.pst .strategy-answer-bottom{display:flex;gap:15px;align-items:center;border-top:1px solid var(--line);padding-top:22px;margin-top:auto}
.pst .strategy-answer-bottom>p{font-size:12px;line-height:1.5;max-width:310px}
.pst .answer-marker{font-size:34px;line-height:1;flex:0 0 36px;color:#536c25}
.pst .strategy-answer-bottom{margin-top:27px}
.pst .move-card{display:flex;flex-direction:column;align-items:flex-start;gap:17px;padding:32px;background:#262c22;color:#f5f8ee;border-radius:13px}
.pst .move-card>.eyebrow{color:#c7d1b9}
.pst .move-card h2{font-size:29px;font-weight:500;line-height:1.1;letter-spacing:-.045em;max-width:240px}
.pst .move-card>p:not(.eyebrow):not(.fine){font-size:13px;line-height:1.7;color:#d0d8c4}
.pst .move-card .btn{margin-top:auto;width:100%;gap:12px}
.pst .move-card .fine{color:#bcc9a9}
.pst .profile-strip{display:grid;grid-template-columns:1fr .9fr 1fr auto;align-items:center;gap:20px;border-bottom:1px solid var(--line);padding:27px 0;margin-top:0}
.pst .profile-strip>div>span{display:block;font-size:10px;color:var(--muted);margin-bottom:7px}
.pst .profile-strip strong{font-size:13px;line-height:1.4;font-weight:500;display:block}
.pst .profile-strip .text-button{font-size:11px}
.pst .quick-reasons{padding-top:25px}
.pst .section-title{display:flex;justify-content:space-between;align-items:center;gap:24px;margin-bottom:18px}
.pst .section-title h2{font-size:23px}
.pst .section-title .text-button{font-size:11px}
.pst .quick-reasons ol{list-style:none;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:25px;padding:0;margin:0}
.pst .quick-reasons li{border-top:1px solid var(--line);padding-top:18px}
.pst .quick-reasons li>span{font-size:10px;color:#68764e;font-variant-numeric:tabular-nums}
.pst .quick-reasons li>p{font-size:12px;line-height:1.7;margin-top:10px;color:#58614e}
.pst .result-footnote{font-size:10px;color:var(--muted);margin-top:28px}
.pst .priority-checks{background:#fbf5ea;border:1px solid #e1d5bd;border-radius:8px;padding:22px 24px;margin:24px 0}
.pst .priority-heading{display:flex;gap:13px;align-items:center;margin-bottom:10px}
.pst .priority-checks h2{font-size:20px}
.pst .signal{display:grid;place-items:center;border:1px solid #96733a;color:#76531e;border-radius:50%;width:23px;height:23px;flex:0 0 23px;font-size:13px}
.pst .priority-checks details{border-top:1px solid #e8dcc7;padding:12px 0}
.pst .priority-checks details:last-of-type{padding-bottom:0}
.pst .priority-checks summary{font-size:13px;font-weight:600;cursor:pointer}
.pst .priority-checks p,.pst .priority-checks li{font-size:13px;line-height:1.65;margin-top:10px}
.pst .conditions,.pst .answer-evidence{padding-left:20px;margin:14px 0 0}
.pst .conditions li,.pst .answer-evidence li{margin-bottom:10px}
.pst .answer-evidence{font-size:12px;color:var(--muted)}
.pst .reason-list{display:grid;gap:0;background:#fff;border:1px solid var(--line);border-radius:10px;padding:0 28px}
.pst .reason-list article{display:flex;gap:25px;border-bottom:1px solid var(--line);padding:27px 0}
.pst .reason-list article:last-child{border:0}
.pst .row-number{font-size:11px;padding-top:4px;color:#798669}
.pst .reason-list h2{font-size:20px;font-weight:500;line-height:1.35;letter-spacing:-.025em}
.pst .reason-list details{margin-top:12px}
.pst .reason-list summary{font-size:11px;color:var(--muted)}
.pst summary{cursor:pointer}
.pst summary::marker{color:#6c7b52}
.pst .detail-section{padding:30px 0;border-bottom:1px solid var(--line)}
.pst .detail-section>h2{margin-bottom:20px}
.pst .detail-section>p{color:var(--muted);font-size:14px;margin-bottom:20px}
.pst .detail-section>summary{font-size:14px;font-weight:500}
.pst .strategy-comparisons{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px}
.pst .strategy-compare{background:#fff;border:1px solid var(--line);border-radius:8px;padding:25px}
.pst .strategy-compare:only-child{grid-column:1 / -1}
.pst .strategy-compare h3{font-size:27px;margin:10px 0 12px}
.pst .strategy-compare p{font-size:14px;color:var(--muted)}
.pst .strategy-compare dl{margin:22px 0 0}
.pst .strategy-compare dl>div{display:grid;grid-template-columns:130px minmax(0,1fr);gap:24px;padding:13px 0;border-top:1px solid var(--line)}
.pst .strategy-compare dt{font-size:11px;color:var(--muted)}
.pst .strategy-compare dd{margin:0;font-size:13px;line-height:1.6}
.pst .watch-panel,.pst .quiet-panel{background:#fff;border:1px solid var(--line);padding:27px;border-radius:8px;margin:28px 0}
.pst .watch-panel h2{margin:13px 0 18px}
.pst .watch-panel p,.pst .quiet-panel p{font-size:14px;line-height:1.7;max-width:750px;color:var(--muted)}
.pst .watch-panel details{margin-top:22px;font-size:13px}
.pst .quiet-panel h2{margin-bottom:16px}
.pst .panel-next{display:flex;justify-content:flex-end;padding:30px 0 10px}
.pst .strategy-process{padding:32px 0;border-bottom:1px solid var(--line)}
.pst .strategy-process>.eyebrow{color:var(--muted);margin-bottom:25px}
.pst .strategy-process ol{display:flex;list-style:none;padding:0;margin:0 0 20px}
.pst .strategy-process li{flex:1;padding-top:22px;padding-right:15px;border-top:1px solid #aab69a;position:relative}
.pst .strategy-process li:before{content:'';position:absolute;top:-5px;left:0;width:9px;height:9px;border:1px solid #657a42;border-radius:50%;background:var(--paper)}
.pst .strategy-process li:first-child:before{background:var(--accent)}
.pst .strategy-process li:last-child{border-color:transparent}
.pst .strategy-process li span{display:block;font-size:10px;color:var(--muted);margin-bottom:9px}
.pst .strategy-process strong{display:block;font-size:13px;font-weight:500;line-height:1.4}
/* Profile, funding and actions */
.pst .identity-panel{background:var(--ink);color:#fff;border-radius:11px;padding:30px;display:grid;grid-template-columns:auto 1.2fr 1fr;gap:22px;align-items:center}
.pst .identity-symbol{font-size:43px;color:var(--accent)}
.pst .identity-panel .eyebrow{color:#bdc8ad;font-size:9px}
.pst .identity-panel h2{font-size:33px;margin:9px 0 10px;font-weight:500}
.pst .identity-panel p:not(.eyebrow){font-size:12px;line-height:1.6;color:#d4dcc9}
.pst .identity-value{border-left:1px solid #56614a;padding-left:24px}
.pst .profile-facts{display:grid;grid-template-columns:1fr 1fr;gap:25px;padding:25px 0;margin:0;border-bottom:1px solid var(--line)}
.pst .profile-facts dt{font-size:10px;color:var(--muted);margin-bottom:10px}
.pst .profile-facts dd{font-size:14px;margin:0}
.pst .context-note{font-size:12px;line-height:1.6;color:var(--muted);margin:20px 0}
.pst .section-intro{font-size:13px;color:var(--muted);max-width:740px;margin-bottom:24px}
.pst .risk-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.pst .risk-axis{padding:25px;background:#fff;border:1px solid var(--line);border-radius:8px}
.pst .risk-axis h3{font-size:12px;font-weight:500;letter-spacing:0;color:var(--muted)}
.pst .axis-value{font-size:24px;font-weight:500;letter-spacing:-.04em;margin-top:10px}
.pst .risk-segments{display:grid;grid-template-columns:repeat(var(--segments),minmax(0,1fr));gap:6px;list-style:none;margin:27px 0 17px;padding:0}
.pst .risk-segments li{font-size:9px;line-height:1.4;color:var(--muted)}
.pst .segment-mark{display:block;height:7px;background:#e3e8dc;margin-bottom:10px;border-radius:2px}
.pst .chosen .segment-mark{background:#536b2d;position:relative}
.pst .chosen .segment-mark:after{content:'';width:9px;height:9px;border:2px solid #fff;box-shadow:0 0 0 1px #536b2d;border-radius:50%;position:absolute;left:50%;top:-1px}
.pst .risk-segments .chosen{color:#3c501d;font-weight:600}
.pst .risk-axis .fine{font-size:10px;line-height:1.6}
.pst .capacity-card{padding:27px;background:#e9efdf;border:1px solid #cfd8c0;border-radius:8px;margin-top:26px}
.pst .capacity-card .eyebrow{color:#607246}
.pst .capacity-card h2{font-size:25px;margin:12px 0}
.pst .capacity-card p{font-size:13px;line-height:1.7;max-width:740px}
.pst .capacity-card details{margin-top:18px;font-size:12px}
.pst .capacity-card details p{margin-top:15px}
.pst .skill-tags{display:flex;flex-wrap:wrap;gap:10px;list-style:none;padding:0;margin:0 0 16px}
.pst .skill-tags li{background:white;border:1px solid var(--line);border-radius:4px;font-size:12px;padding:9px 13px}
.pst .goal-panel{padding:28px 0}
.pst .goal-panel h2{font-size:25px;max-width:700px;margin:14px 0 16px}
.pst .goal-panel p:not(.eyebrow){font-size:12px;margin-top:10px;color:var(--muted)}
.pst .funding-stage{padding:18px 0 30px}
.pst .funding-stage-head{display:flex;align-items:center;gap:17px;margin-bottom:25px}
.pst .stage-number{display:grid;place-items:center;width:42px;height:42px;border-radius:50%;background:var(--ink);color:var(--accent);font-size:11px;flex:0 0 42px}
.pst .funding-stage-head .eyebrow{color:var(--muted);font-size:9px;margin-bottom:6px}
.pst .funding-stage-head h2{font-size:25px}
.pst .stage-intro{font-size:13px;color:var(--muted);margin:0 0 20px}
.pst .funding-stack{border:1px solid var(--line);border-radius:9px;background:white;overflow:hidden}
.pst .funding-option{border-bottom:1px solid var(--line)}
.pst .funding-option:last-child{border:0}
.pst .funding-option>summary{list-style:none;display:flex;align-items:center;justify-content:space-between;gap:25px;padding:24px 27px}
.pst .funding-option summary::-webkit-details-marker{display:none}
.pst .funding-option summary strong{display:block;font-size:20px;line-height:1.2;font-weight:500;letter-spacing:-.025em}
.pst .funding-option summary>span>span{display:block;font-size:12px;color:var(--muted);margin-top:8px}
.pst .expand-icon{font-size:23px;line-height:1;font-weight:400;width:28px;height:28px;display:grid;place-items:center;background:var(--soft);border-radius:50%;flex:0 0 28px}
.pst .funding-option[open] .expand-icon{transform:rotate(45deg)}
.pst .funding-detail{padding:0 27px 27px;max-width:760px;font-size:14px;line-height:1.65;color:var(--muted)}
.pst .funding-detail h3{font-size:12px;letter-spacing:0;font-weight:600;margin:20px 0 10px;color:var(--ink)}
.pst .next-actions{list-style:none;padding:0;margin:0 0 30px}
.pst .next-actions li{display:flex;gap:27px;padding:28px;border:1px solid var(--line);background:#fff;border-radius:8px;margin-bottom:12px}
.pst .next-actions li:first-child{background:#edf3df;border-color:#b9c69e}
.pst .action-number{font-size:30px;letter-spacing:-.06em;font-weight:500;color:#74865b;line-height:1.2}
.pst .next-actions .eyebrow{font-size:9px;color:var(--muted)}
.pst .next-actions p{font-size:15px;line-height:1.65;margin-top:10px;max-width:740px}
.pst .keep-report{display:grid;grid-template-columns:1fr auto;gap:30px;background:#fff;border:1px solid var(--line);padding:30px;border-radius:10px;margin-top:28px}
.pst .keep-report h2{font-size:32px;margin:14px 0}
.pst .keep-report>div>p:not(.eyebrow){font-size:13px;color:var(--muted);max-width:350px}
.pst .keep-report .fine{font-size:10px;margin-top:12px;line-height:1.6}
.pst .keep-report .text-button{font-size:11px;margin-top:7px}
/* Dialogs keep utilities out of the task */
.pst dialog{border:1px solid #d8ddce;border-radius:13px;max-width:540px;width:calc(100% - 32px);max-height:85svh;padding:30px;color:var(--ink);background:#fff;box-shadow:0 30px 100px #19231533}
.pst dialog::backdrop{background:#1d251b66;backdrop-filter:blur(4px)}
.pst .dialog-top{display:flex;align-items:center;justify-content:space-between;gap:20px;margin-bottom:22px}
.pst .dialog-top>.eyebrow{color:var(--muted)}
.pst .close-button{width:38px;height:38px;display:grid;place-items:center;background:var(--soft);border-radius:50%;font-size:26px;font-weight:400}
.pst dialog h2{font-size:31px;margin-bottom:22px}
.pst dialog p{font-size:13px;line-height:1.7;color:var(--muted);margin-top:16px}
.pst dialog label{font-size:12px;display:block;margin-top:24px}
.pst dialog select{display:block;width:100%;max-width:100%;border:1px solid var(--line);background:var(--paper);border-radius:5px;padding:12px;margin:8px 0 22px;font-size:13px}
.pst dialog .btn{width:100%}
.pst .menu-actions{display:flex;flex-direction:column;gap:12px}
.pst .menu-actions .text-button{margin-top:4px}
.pst .print-report{display:none}
.pst .callout{padding:20px;background:#fbf1e2;border:1px solid #deccac;border-radius:7px;margin:20px 0;font-size:13px}
@keyframes pst-view-in{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}
@media(min-width:1450px){
.pst .workspace-top{padding-left:56px;padding-right:56px}
.pst .wrap{padding-left:56px;padding-right:56px}
.pst .start-canvas{gap:54px;padding:54px}
.pst .plan-preview{padding:31px}
.pst .preview-route-item h2{font-size:28px}
.pst .plan-preview .preview-route-item p{font-size:13px}
.pst .product-footer{padding-left:56px;padding-right:56px}
}
@media(max-width:1150px){
.pst .product-shell{grid-template-columns:190px minmax(0,1fr)}
.pst .workspace-side{padding:29px 18px 18px}
.pst .brand{font-size:21px}
.pst .brand-mark{transform:scale(.9);transform-origin:left center;width:29px}
.pst .workspace-top{padding:0 28px}
.pst .wrap{padding:32px 28px 20px}
.pst .product-footer{padding-left:28px;padding-right:28px}
.pst .start-canvas{padding:32px;gap:28px;min-height:500px}
.pst .start-copy h1{font-size:59px}
.pst .start-copy>.eyebrow{font-size:8px;letter-spacing:.09em}
.pst .start-lede{font-size:14px}
.pst .start-action>p{font-size:9px;gap:6px}
.pst .plan-preview{padding:22px 18px;min-height:400px}
.pst .preview-route-item{gap:13px}
.pst .preview-route-item h2{font-size:22px}
.pst .preview-route-item small{font-size:7px}
.pst .preview-route-item p{font-size:10px}
.pst .preview-signature{font-size:7px}
.pst .author img{width:39px;height:48px}
.pst .author small{font-size:8px}
.pst .author span{font-size:10px}
.pst .overview-grid{gap:16px}
.pst .strategy-answer,.pst .move-card{padding:25px}
.pst .move-card h2{font-size:26px}
.pst .move-card>p:not(.eyebrow):not(.fine){font-size:12px}
.pst .move-card .btn{font-size:12px;padding:15px}
.pst .profile-strip{grid-template-columns:1fr 1fr 1fr}
.pst .profile-strip>.text-button{grid-column:1/-1;padding:0;justify-content:flex-start;margin-top:-6px}
.pst .identity-panel{grid-template-columns:auto 1fr}
.pst .identity-value{grid-column:1/-1;border:0;border-top:1px solid #56614a;padding:18px 0 0}
.pst .question-wrap{max-width:730px;padding:38px 38px 20px}
}
@media(max-width:900px) and (min-width:701px){
.pst .start-canvas{grid-template-columns:1fr}
.pst .start-copy h1 br:nth-child(2){display:none}
.pst .start-copy h1{font-size:64px}
.pst .start-copy h1>span{display:block}
.pst .plan-preview{display:none}
.pst .start-canvas{min-height:530px}
.pst .start-lede{font-size:16px}
.pst .start-action{max-width:330px}
.pst .start-note{align-items:flex-start;flex-direction:column;gap:3px}
.pst .overview-grid{grid-template-columns:1fr}
.pst .strategy-answer{min-height:300px}
.pst .move-card h2{max-width:none}
.pst .move-card .btn{width:auto;min-width:240px}
.pst .quick-reasons ol{grid-template-columns:1fr;gap:15px}
.pst .quick-reasons li{display:flex;gap:17px;align-items:baseline}
.pst .quick-reasons li>p{margin-top:0}
.pst .risk-grid{grid-template-columns:1fr}
.pst .keep-report{grid-template-columns:1fr}
.pst .strategy-comparisons{grid-template-columns:1fr}
}
@media(max-width:700px){
html:has(.pst){scroll-padding-top:130px}
.pst .product-shell{display:block}
.pst .workspace-side{display:none}
.pst .workspace-top{height:75px;padding:0 20px;background:#fafbf7;position:relative}
.pst .workspace-location{display:none}
.pst .mobile-brand{display:flex;font-size:20px}
.pst .brand-mark{width:25px;margin-right:0;transform:scale(.8)}
.pst .brand{gap:7px}
.pst .top-tools{gap:15px}
.pst .tool-button{font-size:10px}
.pst .free-label{font-size:10px}
.pst .info-button{width:23px;height:23px;min-width:23px}
.pst .wrap{padding:26px 20px 20px}
.pst .product-footer{padding:8px 20px 20px;font-size:9px;gap:12px}
.pst .product-footer .text-button{font-size:9px;gap:10px}
.pst .intro-wrap{padding:20px 16px 6px}
.pst .start-canvas{display:block;padding:28px 24px 25px;min-height:0;border-radius:12px}
.pst .start-copy{padding:0}
.pst .start-copy>.eyebrow{margin-bottom:28px;font-size:8px;letter-spacing:.09em;gap:7px}
.pst .start-copy h1{font-size:clamp(52px,13.7vw,76px);line-height:1.01;letter-spacing:-.065em}
.pst .start-lede{font-size:14px;line-height:1.6;max-width:330px;margin-top:21px}
.pst .start-action{margin-top:26px;max-width:none}
.pst .start-action .btn{min-height:55px}
.pst .start-action>p{font-size:9px;gap:9px;margin:13px 0 0}
.pst .plan-preview{margin-top:30px;min-height:0;padding:20px 18px;border-radius:8px}
.pst .plan-preview-top{font-size:8px}
.pst .plan-preview-top>span:last-child{font-size:21px}
.pst .preview-route{display:grid;grid-template-columns:repeat(3,1fr);gap:13px;padding:22px 0 3px}
.pst .preview-route-item{display:block;padding-bottom:0}
.pst .preview-route-item:not(:last-child):before{display:none}
.pst .route-point{width:25px;height:25px;font-size:8px;margin-bottom:13px}
.pst .preview-route-item small{display:none}
.pst .preview-route-item h2{font-size:16px;line-height:1.15;margin:0;letter-spacing:-.035em}
.pst .preview-route-item p,.pst .preview-signature{display:none}
.pst .start-note{font-size:10px;align-items:flex-start;padding:16px 8px;gap:12px}
.pst .start-note>p{max-width:185px;line-height:1.6}
.pst .start-note .text-button{font-size:10px;padding:0;min-height:32px;gap:9px}
.pst .example{padding:8px 20px;font-size:9px;line-height:1.5;gap:9px}
.pst .example>span{font-size:8px}
.pst .question-wrap{padding:29px 22px 15px}
.pst .question-meta{font-size:9px;gap:15px;margin-bottom:13px}
.pst .question-meta>span:last-child{white-space:nowrap}
.pst .question-progress{margin-bottom:27px}
.pst .question{font-size:29px;line-height:1.15;letter-spacing:-.045em}
.pst .hint{font-size:12px;margin:15px 0 23px;line-height:1.6}
.pst .option{padding:15px 14px;gap:12px;min-height:62px;margin-bottom:10px}
.pst .option-index{font-size:9px}
.pst .option-label{font-size:13px;line-height:1.55}
.pst .option-indicator{width:17px;height:17px;flex-basis:17px}
.pst .question-actions{margin-top:24px;padding:18px 0 16px;padding-bottom:max(16px,env(safe-area-inset-bottom));bottom:0}
.pst .question-actions .btn{min-width:176px}
.pst .question-actions .text-button{font-size:12px;min-height:44px}
.pst .question-why{margin:6px 0 12px}
.pst .scenario,.pst .comparison{gap:10px}
.pst .scenario-card,.pst .comparison>div{padding:14px}
.pst .scenario h2,.pst .comparison h2{font-size:18px}
.pst .scenario p,.pst .comparison p{font-size:11px}
.pst .view-heading{margin-bottom:27px}
.pst .view-heading>.eyebrow{font-size:9px;margin-bottom:17px}
.pst .view-heading h1{font-size:38px;line-height:1.06;letter-spacing:-.055em}
.pst .view-heading>p:last-child{font-size:13px;margin-top:16px}
.pst .review-ready{align-items:stretch;flex-direction:column;padding:20px;gap:18px}
.pst .review-ready p{font-size:13px}
.pst .review-ready .btn{width:100%}
.pst .answer-group>summary{font-size:13px;gap:12px;padding:22px 0}
.pst .answer-group>summary>span:last-child{font-size:9px;gap:9px;white-space:nowrap}
.pst .answer-group dl{padding:0 16px}
.pst .summary-row{padding:20px 0;gap:13px}
.pst .summary-row dt{font-size:11px}
.pst .summary-row dd{font-size:12px}
.pst .summary-row .link{font-size:11px}
.pst .mobile-report-nav{display:flex;overflow-x:auto;gap:0;background:#fafbf7;border-bottom:1px solid var(--line);padding:0 14px;position:sticky;top:0;z-index:10;scrollbar-width:none}
.pst .mobile-report-nav::-webkit-scrollbar{display:none}
.pst .mobile-report-nav button{display:flex;align-items:center;gap:5px;flex:1 0 auto;justify-content:center;padding:16px 7px 13px;font-size:11px;background:transparent;color:var(--muted);border-bottom:3px solid transparent;white-space:nowrap}
.pst .mobile-report-nav .nav-number,.pst .mobile-report-nav .nav-arrow{display:none}
.pst .mobile-report-nav button[aria-current]{color:var(--ink);font-weight:600;border-bottom-color:#6a812d}
.pst .result-wrap{padding:24px 18px 18px}
.pst .overview-grid{grid-template-columns:1fr;gap:16px}
.pst .strategy-answer{padding:26px;min-height:285px;border-radius:10px}
.pst .strategy-answer>.eyebrow{font-size:9px;margin-bottom:25px}
.pst .strategy-answer h1{font-size:44px;line-height:1.02}
.pst .strategy-answer h1.short-name{font-size:85px}
.pst .strategy-subtitle{font-size:13px;margin-top:18px}
.pst .strategy-answer-bottom{margin-top:26px;padding-top:19px}
.pst .strategy-answer-bottom>p{font-size:11px}
.pst .move-card{padding:25px;border-radius:10px;gap:17px}
.pst .move-card h2{font-size:30px;max-width:250px}
.pst .move-card>p:not(.eyebrow):not(.fine){font-size:13px;line-height:1.7}
.pst .move-card .btn{margin-top:4px;font-size:14px;min-height:53px;padding:16px 20px}
.pst .move-card>.eyebrow{font-size:9px}
.pst .profile-strip{grid-template-columns:1fr 1fr;gap:20px 16px;padding:25px 4px}
.pst .profile-strip>div>span{font-size:10px}
.pst .profile-strip strong{font-size:13px}
.pst .profile-strip .text-button{grid-column:auto;padding:0;margin:0;align-self:center;line-height:1.5;gap:9px;font-size:11px}
.pst .quick-reasons{padding:25px 4px 0}
.pst .section-title{gap:18px;align-items:center;margin-bottom:17px}
.pst .section-title h2{font-size:21px;max-width:230px}
.pst .section-title .text-button{font-size:10px;gap:8px}
.pst .quick-reasons ol{grid-template-columns:1fr;gap:15px}
.pst .quick-reasons li{display:flex;gap:17px;align-items:baseline;padding-top:15px}
.pst .quick-reasons li>p{font-size:12px;margin:0}
.pst .result-footnote{font-size:10px;padding:0 4px;line-height:1.6}
.pst .priority-checks{padding:20px;margin:20px 0}
.pst .priority-checks h2{font-size:19px}
.pst .priority-checks summary{font-size:12px;line-height:1.6}
.pst .priority-checks p,.pst .priority-checks li{font-size:12px}
.pst .priority-heading{align-items:flex-start}
.pst .reason-list{padding:0 20px}
.pst .reason-list article{gap:17px;padding:22px 0}
.pst .reason-list h2{font-size:17px;line-height:1.45}
.pst .reason-list summary{font-size:10px}
.pst .strategy-process{padding:28px 0}
.pst .strategy-process strong{font-size:11px}
.pst .strategy-process li{padding-right:9px}
.pst .strategy-process .fine{font-size:10px}
.pst .strategy-comparisons{grid-template-columns:1fr}
.pst .strategy-compare{padding:22px}
.pst .strategy-compare h3{font-size:25px}
.pst .strategy-compare p{font-size:13px}
.pst .strategy-compare dl>div{grid-template-columns:1fr;gap:7px;padding:13px 0}
.pst .strategy-compare dd{font-size:12px}
.pst .detail-section{padding:25px 0}
.pst .detail-section>h2{font-size:23px}
.pst .detail-section>summary{font-size:13px}
.pst .watch-panel,.pst .quiet-panel{padding:23px}
.pst .watch-panel p,.pst .quiet-panel p{font-size:13px}
.pst .panel-next .btn{width:100%}
.pst .identity-panel{padding:24px;gap:17px;grid-template-columns:auto 1fr}
.pst .identity-panel h2{font-size:27px}
.pst .identity-symbol{font-size:34px}
.pst .identity-panel p:not(.eyebrow){font-size:11px}
.pst .identity-panel .identity-value{font-size:12px}
.pst .profile-facts{gap:20px}
.pst .profile-facts dd{font-size:12px}
.pst .context-note{font-size:11px}
.pst .risk-grid{grid-template-columns:1fr;gap:13px}
.pst .risk-axis{padding:23px}
.pst .risk-axis h3{font-size:12px}
.pst .axis-value{font-size:25px}
.pst .risk-segments li{font-size:9px}
.pst .risk-axis .fine{font-size:10px}
.pst .capacity-card{padding:23px}
.pst .capacity-card h2{font-size:24px}
.pst .capacity-card p{font-size:12px}
.pst .goal-panel h2{font-size:23px;line-height:1.2}
.pst .funding-stage-head{gap:13px;margin-bottom:21px}
.pst .funding-stage-head h2{font-size:23px}
.pst .funding-option>summary{padding:22px 20px;gap:17px}
.pst .funding-option summary strong{font-size:19px}
.pst .funding-option summary>span>span{font-size:11px;line-height:1.6}
.pst .funding-detail{padding:0 20px 23px;font-size:12px}
.pst .next-actions li{padding:23px 20px;gap:20px}
.pst .action-number{font-size:26px}
.pst .next-actions p{font-size:13px;line-height:1.7}
.pst .keep-report{grid-template-columns:1fr;padding:24px;gap:25px}
.pst .keep-report .btn{width:100%}
.pst .keep-report h2{font-size:29px}
.pst .keep-report .fine{font-size:10px}
.pst .keep-report .text-button{min-height:44px}
.pst dialog{padding:24px}
.pst dialog h2{font-size:27px}
.pst .menu-actions .text-button{min-height:44px}
}
@media(max-width:360px){
.pst .mobile-brand{font-size:18px}
.pst .workspace-top{padding:0 16px}
.pst .top-tools{gap:12px}
.pst .start-canvas{padding:26px 20px 23px}
.pst .start-copy h1{font-size:49px}
.pst .start-action>p{font-size:8px;gap:7px}
.pst .preview-route-item h2{font-size:14px}
.pst .question-wrap{padding-left:18px;padding-right:18px}
.pst .question{font-size:27px}
.pst .question-meta{font-size:8px}
.pst .profile-strip{grid-template-columns:1fr}
.pst .mobile-report-nav button{font-size:10px;padding-left:9px;padding-right:9px}
.pst .strategy-answer h1{font-size:40px}
}
@media(prefers-reduced-motion:reduce){
.pst *,.pst *:before,.pst *:after{animation:none!important;transition:none!important;scroll-behavior:auto!important}
.pst .btn:hover{transform:none}
}
@media print{
/* Every screen prints without the app frame. The result screen prints only the designed report from src/report-pdf.mjs
(inside .print-report), whose own stylesheet sets the A4 page. all:initial gives it the same clean start as the download. */
.pst{background:#fff!important;height:auto!important;overflow:visible!important}
html:has(.pst){background:#fff!important;height:auto!important;overflow:visible!important}
.pst .skip,.pst #live,.pst dialog,.pst .workspace-side,.pst .workspace-top,.pst .mobile-report-header,.pst .example,.pst .product-footer{display:none!important}
.pst .product-shell,.pst .workspace-main,.pst .wrap{display:block!important;min-height:0!important;max-width:none!important;margin:0!important;padding:0!important;overflow:visible!important}
.pst[data-screen="result"]>:not(.product-shell),.pst[data-screen="result"] .product-shell>:not(.workspace-main),.pst[data-screen="result"] .workspace-main>:not(main),.pst[data-screen="result"] .result-wrap>:not(.print-report){display:none!important}
.pst[data-screen="result"] .print-report{all:initial;display:block!important;font-variant-ligatures:none}
}
/* Programmatic heading focus announces each new view without a decorative focus box. */
.pst h1[tabindex="-1"]:focus,.pst main[tabindex="-1"]:focus{outline:none}
/* Report 0.25: five chapters, one reading path, the same content in every format. */
.pst .report-overview{max-width:780px;padding:12px 0 26px}
.pst .report-overview>.eyebrow{display:flex;align-items:center;gap:9px;margin-bottom:24px}
.pst .report-overview h1,.pst .report-overview h2{font-size:clamp(40px,5vw,66px);line-height:1.04;max-width:750px;font-weight:500}
.pst .report-lede{font-size:19px;line-height:1.65;margin-top:24px;max-width:680px}
.pst .report-key-points{display:grid;gap:12px;margin:12px 0 28px}
.pst .report-key-points article{padding:20px 24px;background:#fff;border:1px solid var(--line);border-radius:7px}
.pst .report-key-points .eyebrow{color:var(--accent-deep)}
.pst .report-key-points p{font-size:15px;line-height:1.7;margin-top:9px;max-width:780px}
.pst .report-key-points .priority-point{border-left:4px solid var(--accent-deep);background:var(--soft)}
.pst .report-alert{padding:24px;background:var(--soft);border-left:4px solid var(--accent-deep);margin:24px 0}
.pst .report-alert h2{font-size:23px}
.pst .report-alert p{margin:14px 0;line-height:1.7}
.pst .profile-strip{grid-template-columns:repeat(3,minmax(0,1fr))}
.pst .overview-reason{padding:28px 0;max-width:720px}
.pst .overview-reason h2{margin:12px 0 18px;font-size:27px}
.pst .overview-reason p:not(.eyebrow){line-height:1.75;margin:12px 0}
.pst .report-pagination{position:sticky;bottom:0;z-index:12;background:rgba(244,245,239,.97);backdrop-filter:blur(12px);border-top:1px solid var(--line);margin:28px -8px -12px;padding:15px 8px max(15px,env(safe-area-inset-bottom));display:flex;justify-content:space-between;align-items:center;gap:16px}
.pst .report-pagination .text-button{min-height:48px}
.pst .report-pagination .btn{max-width:80%;gap:14px}
.pst .chapter-position{font-size:12px;color:var(--muted)}
.pst .result-wrap{padding-bottom:26px;overflow:visible}
.pst .mobile-report-header{display:none}
.pst .reason-list article>div>p{font-size:16px;line-height:1.75;margin-top:13px}
.pst .reason-list .context-note{font-size:14px!important}
.pst .reason-list h2{font-size:25px;line-height:1.25}
.pst .claim-evidence{margin-top:18px}
.pst .claim-evidence summary{min-height:44px;display:list-item;cursor:pointer;font-size:13px;color:var(--accent-deep);font-weight:600;padding:10px 0}
.pst .answer-evidence{font-size:13px;line-height:1.65}
.pst .profile-narrative{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.pst .profile-narrative article{background:white;border:1px solid var(--line);border-radius:8px;padding:27px}
.pst .profile-narrative h2{font-size:24px;line-height:1.2;margin-bottom:17px}
.pst .profile-narrative p{font-size:15px;line-height:1.75;margin-top:12px}
.pst .profile-narrative .fine{font-size:13px}
.pst .activity-route{margin:35px 0}
.pst .activity-route ol{display:grid;grid-template-columns:repeat(auto-fit,minmax(125px,1fr));gap:16px;list-style:none;padding:0;margin:20px 0}
.pst .activity-route li{border-top:3px solid var(--accent-deep);padding:15px 4px}
.pst .activity-route li>span{display:block;font-size:11px;color:var(--muted);margin-bottom:10px}
.pst .activity-route strong{font-weight:500;font-size:17px}
.pst .route-branch{padding:17px 20px;border-left:2px solid var(--accent-deep);background:var(--soft);font-size:14px;line-height:1.7}
.pst .watch-panel h2{font-size:29px}
.pst .watch-panel p:not(.eyebrow){font-size:16px;line-height:1.75}
.pst .risk-axis{background:white}
.pst .risk-axis h3{font-size:15px}
.pst .risk-axis .fine{font-size:13px}
.pst .risk-segments li{font-size:11px}
.pst .loss-boundary{padding:26px 0;border-top:1px solid var(--line);border-bottom:1px solid var(--line);margin:28px 0}
.pst .loss-boundary h2{font-size:25px;line-height:1.3;margin:13px 0}
.pst .loss-boundary p:not(.eyebrow){font-size:15px;line-height:1.75}
.pst .capacity-card p{font-size:15px;line-height:1.75;margin-top:13px}
.pst .goal-panel p{font-size:15px;line-height:1.75;margin-top:12px}
.pst .goal-panel .fine{font-size:13px}
.pst .participation-stack{display:grid;gap:18px}
.pst .participation-stack article,.pst .funding-questions{background:white;border:1px solid var(--line);padding:28px;border-radius:8px}
.pst .participation-stack h2{margin:13px 0 18px;font-size:27px}
.pst .participation-stack p:not(.eyebrow){margin:13px 0;line-height:1.75}
.pst .funding-stack{display:grid;gap:18px}
.pst .funding-card{background:white;border:1px solid var(--line);padding:27px;border-radius:8px}
.pst .funding-card h3{font-size:26px;margin-bottom:14px}
.pst .funding-card p{font-size:15px;line-height:1.75;margin-top:13px}
.pst .funding-purpose{font-weight:500}
.pst .funding-check{border-top:1px solid var(--line);margin-top:20px;padding-top:17px}
.pst .funding-check h4{font-size:16px;letter-spacing:0}
.pst .funding-stage>p{font-size:15px;line-height:1.75;margin-bottom:20px}
.pst .funding-questions ol{padding-left:23px;margin:26px 0 0}
.pst .funding-questions li{padding-left:9px;margin-top:25px}
.pst .funding-questions h3{font-size:21px;margin-bottom:10px}
.pst .funding-questions p{font-size:15px;line-height:1.75}
.pst .learning-exercise{background:white;border:1px solid var(--line);border-radius:9px;padding:32px;margin:25px 0}
.pst .learning-exercise>.eyebrow{color:var(--accent-deep);margin-bottom:17px}
.pst .learning-exercise h2{font-size:30px;max-width:620px}
.pst .learning-exercise>p:not(.eyebrow){font-size:16px;line-height:1.75;margin-top:17px}
.pst .learning-exercise ol{list-style:none;padding:0;margin:27px 0}
.pst .learning-exercise li{display:flex;gap:23px;border-top:1px solid var(--line);padding:23px 0}
.pst .learning-exercise li>span{font-size:12px;color:var(--accent-deep);padding-top:5px}
.pst .learning-exercise li p{font-size:16px;line-height:1.75}
.pst .exercise-outcome{background:var(--soft);padding:22px;border-radius:5px}
.pst .exercise-outcome strong{font-size:13px;color:var(--accent-deep)}
.pst .exercise-outcome p{font-size:15px;line-height:1.75;margin-top:10px}
.pst .preparation-exercise{border-left:4px solid var(--accent-deep)}
.pst .report-disclaimer{font-size:12px;line-height:1.75;color:var(--muted);margin:24px 0}
.pst .full-report-heading{padding:12px 0 30px}
.pst .full-report-heading h1{font-size:44px;max-width:650px;margin:18px 0}
.pst .full-report-chapter{border-top:2px solid var(--line);padding:38px 0}
.pst .full-report-chapter>.view-heading h2{font-size:37px}
.pst .full-report-chapter .profile-strip{margin-top:20px}
.pst .full-report .view-heading{margin-top:12px}
.pst .full-report-chapter .keep-report{display:none}
.pst .answer-appendix dl>div{border-top:1px solid var(--line);padding:18px 0}
.pst .answer-appendix dt{font-weight:600}
.pst .answer-appendix dd{margin:9px 0 0}
.pst .detail-section>p,.pst .conditions li{line-height:1.75}
.pst .detail-section summary{min-height:44px;padding:10px 0}
.pst .section-title{flex-wrap:wrap}
.pst .text-button .sr-only{font-size:1px}
.pst .btn,.pst .text-button{overflow-wrap:anywhere}
.pst .result-wrap h1,.pst .result-wrap h2,.pst .result-wrap h3{overflow-wrap:break-word}
@media(max-width:900px){
.pst .profile-narrative{grid-template-columns:1fr}
.pst .mobile-report-header{display:flex;justify-content:space-between;align-items:center;gap:15px;padding:14px 22px;background:#fafbf7;border-bottom:1px solid var(--line)}
.pst .mobile-report-header strong{display:block;font-size:14px;font-weight:500;margin-top:4px}
.pst .mobile-report-header .eyebrow{font-size:9px;color:var(--muted)}
.pst .mobile-report-header button{min-height:44px;padding:10px;font-size:12px}
.pst .mobile-report-nav{display:none}
.pst .report-pagination{bottom:0}
}
@media(max-width:600px){
.pst .report-overview{padding-top:10px;padding-bottom:18px}
.pst .report-overview h1,.pst .report-overview h2{font-size:41px;line-height:1.08}
.pst .report-overview>.eyebrow{margin-bottom:20px}
.pst .report-lede{font-size:17px;line-height:1.7;margin-top:21px}
.pst .report-key-points article{padding:20px}
.pst .report-key-points p{font-size:15px}
.pst .profile-strip{grid-template-columns:1fr;gap:20px}
.pst .profile-strip strong{font-size:17px}
.pst .profile-strip>div>span{font-size:11px}
.pst .overview-reason h2{font-size:25px}
.pst .overview-reason p:not(.eyebrow){font-size:16px}
.pst .report-pagination{margin-left:-18px;margin-right:-18px;margin-bottom:-26px;padding-left:18px;padding-right:18px;gap:12px}
.pst .report-pagination .btn{font-size:13px;min-height:54px;max-width:78%;padding:14px 16px;gap:12px}
.pst .report-pagination .text-button{font-size:12px;gap:8px}
.pst .report-alert{padding:21px}
.pst .report-alert h2{font-size:23px}
.pst .reason-list{padding:0 20px}
.pst .reason-list article{gap:13px}
.pst .reason-list h2{font-size:23px;line-height:1.25}
.pst .reason-list article>div>p{font-size:15px}
.pst .reason-list .row-number{font-size:11px}
.pst .claim-evidence summary{font-size:12px}
.pst .profile-narrative article{padding:23px}
.pst .profile-narrative h2{font-size:24px}
.pst .profile-narrative p{font-size:15px}
.pst .risk-axis{padding:22px}
.pst .risk-axis h3{font-size:14px}
.pst .risk-axis .fine{font-size:12px}
.pst .risk-segments li{font-size:10px}
.pst .axis-value{font-size:25px}
.pst .loss-boundary h2{font-size:23px}
.pst .capacity-card p{font-size:15px}
.pst .capacity-card h2{font-size:24px}
.pst .watch-panel h2{font-size:26px}
.pst .watch-panel p:not(.eyebrow){font-size:15px}
.pst .strategy-compare p,.pst .strategy-compare dd{font-size:15px;line-height:1.7}
.pst .strategy-compare h3{font-size:25px}
.pst .strategy-compare dt{font-size:11px}
.pst .activity-route ol{grid-template-columns:1fr 1fr;gap:12px}
.pst .activity-route strong{font-size:16px}
.pst .participation-stack article,.pst .funding-questions,.pst .funding-card{padding:23px}
.pst .funding-card h3{font-size:24px}
.pst .funding-card p{font-size:15px}
.pst .funding-stage-head h2{font-size:25px}
.pst .learning-exercise{padding:23px}
.pst .learning-exercise h2{font-size:27px}
.pst .learning-exercise li{gap:15px}
.pst .learning-exercise li p{font-size:15px}
.pst .exercise-outcome{padding:18px}
.pst .learning-exercise>p:not(.eyebrow){font-size:15px}
.pst .full-report-heading h1{font-size:36px}
.pst .full-report-chapter>.view-heading h2{font-size:32px}
.pst .full-report-chapter{padding:28px 0}
.pst .result-wrap .view-heading>p:last-child{font-size:15px;line-height:1.7}
.pst .result-wrap .context-note{font-size:14px;line-height:1.7}
.pst .result-wrap .conditions li{font-size:15px}
.pst .result-wrap .section-title h2{font-size:25px}
.pst .result-wrap .detail-section>h2{font-size:26px}
}
/* Report 0.27: the strategy first, then funding steps, then a charted investor profile. */
.pst{--mark:#557314;--mark-soft:#c5d79a;--track:#e3e7da;--graphite:#242820}
.pst .strategy-hero{position:relative;overflow:hidden;background:var(--graphite);color:#f4f5ef;border-radius:16px;padding:40px 44px 44px;margin:4px 0 20px}
.pst .strategy-hero:after{content:'';position:absolute;right:-60px;top:-60px;width:220px;height:220px;border-radius:50%;border:1px solid rgba(203,234,82,.18);box-shadow:0 0 0 38px rgba(203,234,82,.04),0 0 0 76px rgba(203,234,82,.03);pointer-events:none}
.pst .strategy-hero-top{display:flex;flex-wrap:wrap;align-items:center;gap:10px 14px;position:relative;z-index:1}
.pst .strategy-hero .eyebrow{display:flex;align-items:center;gap:9px;color:var(--accent);font-size:11px}
.pst .strategy-hero .live-dot{background:var(--accent)}
.pst .strategy-status{font-size:11px;font-weight:600;line-height:1.3;color:#dde3d2;border:1px solid #4a5043;border-radius:999px;padding:5px 11px}
.pst .strategy-name{position:relative;z-index:1;font-size:clamp(52px,6.6vw,96px);line-height:.98;font-weight:600;letter-spacing:-.055em;margin:26px 0 0;max-width:900px;color:#f4f5ef}
.pst .strategy-name:after{content:'';display:block;width:72px;height:6px;border-radius:3px;background:var(--accent);margin-top:26px}
.pst .strategy-what{position:relative;z-index:1;font-size:21px;line-height:1.5;color:#c9d1bc;max-width:660px;margin-top:20px}
.pst .strategy-summary{display:grid;grid-template-columns:minmax(0,1.25fr) minmax(0,1fr);gap:18px;margin:0 0 18px}
.pst .strategy-why,.pst .strategy-route{background:#fff;border:1px solid var(--line);border-radius:14px;padding:28px 30px}
.pst .strategy-why h2,.pst .strategy-route h2{font-size:13px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--accent-deep)}
.pst .strategy-why ol{list-style:none;padding:0;margin:14px 0 6px}
.pst .strategy-why li{display:flex;gap:16px;align-items:baseline;border-top:1px solid var(--line);padding:16px 0}
.pst .strategy-why li:first-child{border-top:0;padding-top:6px}
.pst .strategy-why .row-number{font-size:12px;color:var(--accent-deep);font-variant-numeric:tabular-nums}
.pst .strategy-why li p{font-size:18px;line-height:1.5;letter-spacing:-.01em}
.pst .strategy-route{display:flex;flex-direction:column;align-items:flex-start;gap:16px;background:#f9fbf2;border-color:#d5e0b8}
.pst .strategy-route p{font-size:18px;line-height:1.55;letter-spacing:-.01em}
.pst .strategy-route .btn{margin-top:auto}
.pst .strategy-highlight{background:#fff;border:1px solid var(--line);border-left:4px solid var(--accent-deep);border-radius:10px;padding:20px 24px;margin:0 0 6px}
.pst .strategy-highlight .eyebrow{color:var(--accent-deep)}
.pst .strategy-highlight p:not(.eyebrow){font-size:15px;line-height:1.7;margin-top:8px;max-width:780px}
.pst .strategy-highlight.is-priority{background:var(--soft)}
/* Funding as steps */
.pst .funding-steps{list-style:none;padding:0;margin:6px 0 0}
.pst .funding-step{position:relative;padding:0 0 38px 46px}
.pst .funding-step:before{content:'';position:absolute;left:12px;top:34px;bottom:4px;width:2px;background:var(--line)}
.pst .funding-step:last-child:before{display:none}
.pst .funding-step:after{content:'';position:absolute;left:4px;top:8px;width:14px;height:14px;border-radius:50%;background:var(--accent);border:2px solid var(--graphite)}
.pst .funding-step-head{display:flex;flex-direction:column;align-items:flex-start;gap:8px;margin-bottom:6px}
.pst .step-pill{font-size:10px;font-weight:600;letter-spacing:.13em;text-transform:uppercase;color:var(--accent-deep)}
.pst .funding-step-head h2{font-size:28px;line-height:1.15}
.pst .funding-step-intro{font-size:15px;line-height:1.7;color:var(--muted);max-width:680px;margin-top:6px}
.pst .funding-options{display:grid;gap:12px;margin-top:18px}
.pst .funding-options .funding-card{border-radius:12px;padding:24px 26px;display:flex;flex-direction:column}
.pst .funding-options .funding-card h3{font-size:22px;line-height:1.2;margin:0}
.pst .funding-options .funding-card p{margin-top:10px}
.pst .funding-options .funding-purpose{font-size:16px;font-weight:500;color:var(--ink)}
.pst .funding-options .funding-why{font-size:15px;line-height:1.65;color:#4b5144}
.pst .funding-options .funding-condition{font-size:13px!important;line-height:1.6;color:var(--muted);margin-top:auto!important;padding-top:12px}
.pst .funding-or{display:flex;align-items:center;gap:12px;margin:0}
.pst .funding-or:before,.pst .funding-or:after{content:'';flex:1;height:1px;background:var(--line)}
.pst .funding-or span{display:grid;place-items:center;width:40px;height:40px;border-radius:50%;background:var(--graphite);color:var(--accent);font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase}
.pst .funding-notes{background:#fff;border:1px solid var(--line);border-radius:12px;padding:22px 26px;margin:6px 0 24px}
.pst .funding-notes h2{font-size:13px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--accent-deep)}
.pst .funding-notes .conditions li{font-size:15px;line-height:1.7}
@media(min-width:1100px){
.pst .funding-options.is-count-2{grid-template-columns:minmax(0,1fr) auto minmax(0,1fr)}
.pst .funding-options.is-count-3{grid-template-columns:minmax(0,1fr) auto minmax(0,1fr) auto minmax(0,1fr)}
.pst .funding-options.is-count-2 .funding-or,.pst .funding-options.is-count-3 .funding-or{flex-direction:column}
.pst .funding-options.is-count-2 .funding-or:before,.pst .funding-options.is-count-2 .funding-or:after,.pst .funding-options.is-count-3 .funding-or:before,.pst .funding-options.is-count-3 .funding-or:after{width:1px;height:auto}
}
/* Investor profile charts. Data marks use the validated olive (#557314) on white; lime on graphite on screen. */
.pst .chart-block{margin:44px 0 0}
.pst .chart-block>h2,.pst .chart-block .section-title h2{font-size:27px}
.pst .chart-block .section-title{margin-bottom:8px}
.pst .chart-intro{font-size:15px;line-height:1.7;color:var(--muted);max-width:640px;margin-bottom:20px}
.pst .chart-block>h2{margin-bottom:20px}
.pst .chart-block>.fine{margin-top:14px;font-size:13px}
.pst .chart-hero{display:grid;grid-template-columns:minmax(0,.95fr) minmax(0,1.05fr);grid-template-areas:"head figure" "key figure";gap:6px 44px;align-items:start;border:1px solid var(--line);border-radius:16px;padding:38px 40px;background:#fff;margin:4px 0 0}
.pst .chart-hero-head{grid-area:head}
.pst .chart-hero-head h2{font-size:42px;line-height:1.02;letter-spacing:-.05em;margin-top:14px}
.pst .chart-hero-sub{font-size:15px;color:var(--muted);margin-top:12px}
.pst .chart-hero-figure{grid-area:figure;margin:0;align-self:center}
.pst .chart-radar{display:block;width:100%;height:auto;max-width:500px;margin:0 auto;overflow:visible}
.pst .chart-radar text{font-family:var(--font)}
@media(max-width:480px){
.pst .chart-radar text{font-size:13px}
}
.pst .chart-hero-figure figcaption{font-size:12px;line-height:1.6;color:var(--muted);text-align:center;max-width:420px;margin:12px auto 0}
.pst .radar-key{grid-area:key;list-style:none;padding:0;margin:20px 0 0}
.pst .radar-key li{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:2px 16px;border-top:1px solid var(--line);padding:11px 0}
.pst .radar-key-name{font-size:11px;letter-spacing:.04em;color:var(--muted)}
.pst .radar-key-answer{grid-column:1;font-size:15px;font-weight:500;line-height:1.35}
.pst .radar-key .is-open .radar-key-answer{color:var(--muted);font-weight:400;font-style:italic}
.pst .radar-key-steps{grid-column:2;grid-row:1/3;align-self:center;display:flex;gap:3px}
.pst .radar-key-steps i{display:block;width:10px;height:6px;border-radius:3px;background:var(--track)}
.pst .radar-key-steps i.on{background:var(--mark)}
@media screen{
.pst .chart-hero{background:var(--graphite);border-color:var(--graphite);color:#f4f5ef}
.pst .chart-hero .eyebrow{color:var(--accent)}
.pst .chart-hero-sub,.pst .chart-hero-figure figcaption,.pst .chart-hero .radar-key-name{color:#a9b19c}
.pst .chart-hero .radar-key li{border-color:#3a4034}
.pst .chart-hero .radar-key .is-open .radar-key-answer{color:#9aa38e}
.pst .chart-hero .radar-key-steps i{background:#4a5043}
.pst .chart-hero .radar-key-steps i.on{background:var(--accent)}
.pst .chart-hero .radar-grid{stroke:#4a5043}
.pst .chart-hero .radar-tick{fill:#5c6455}
.pst .chart-hero .radar-area{fill:var(--accent);fill-opacity:.16;stroke:var(--accent)}
.pst .chart-hero .radar-line{stroke:var(--accent)}
.pst .chart-hero .radar-point{fill:var(--accent);stroke:var(--graphite)}
.pst .chart-hero .radar-label{fill:#f4f5ef}
.pst .chart-hero .radar-label.is-open{fill:#8d957f}
}
@media screen and (prefers-reduced-motion:no-preference){
.pst .chart-hero .radar-area,.pst .chart-hero .radar-line{transform-origin:220px 178px;animation:pst-chart-reveal .9s cubic-bezier(.2,.7,.2,1) both}
.pst .chart-hero .radar-point{animation:pst-chart-fade .5s .45s ease-out both}
}
@keyframes pst-chart-reveal{from{opacity:0;transform:scale(.35)}to{opacity:1;transform:none}}
@keyframes pst-chart-fade{from{opacity:0}to{opacity:1}}
.pst .chart-pair{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}
.pst .chart-card{background:#fff;border:1px solid var(--line);border-radius:14px;padding:26px 28px}
.pst .chart-card h3,.pst .goal-figures dt,.pst .goal-motive span,.pst .chart-limits span{display:block;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--muted)}
.pst .chart-value{font-size:22px;line-height:1.25;font-weight:500;letter-spacing:-.025em;margin:10px 0 18px}
.pst .chart-card .fine{margin-top:12px}
.pst .chart-scale{list-style:none;padding:0;margin:0;display:grid;grid-template-columns:repeat(var(--steps),minmax(0,1fr));gap:4px}
.pst .chart-scale li{font-size:11px;line-height:1.35;color:var(--muted);min-width:0}
.pst .chart-scale-bar{display:block;height:10px;border-radius:5px;background:var(--track);margin-bottom:9px}
.pst .chart-scale .is-filled .chart-scale-bar{background:var(--mark-soft)}
.pst .chart-scale .is-picked .chart-scale-bar{background:var(--mark);box-shadow:0 0 0 3px rgba(203,234,82,.6)}
.pst .chart-scale .is-picked{color:var(--ink);font-weight:600}
.pst .chart-scale-label{display:block;overflow-wrap:break-word}
.pst .chart-scale-ends{display:flex;justify-content:space-between;gap:12px;font-size:11px;color:var(--muted);margin-top:8px;letter-spacing:.02em}
.pst .chart-goal{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:24px 44px;background:#fff;border:1px solid var(--line);border-radius:16px;padding:34px 36px}
.pst .chart-goal>.chart-scale,.pst .chart-goal>.chart-scale-ends,.pst .chart-goal>.fine{grid-column:1/-1}
.pst .chart-goal>.chart-scale-ends{margin-top:-16px}
.pst .chart-goal>.fine{margin-top:-6px}
.pst .goal-main .eyebrow{color:var(--accent-deep)}
.pst .goal-main h2{font-size:34px;line-height:1.08;letter-spacing:-.045em;margin-top:14px}
.pst .goal-motive{font-size:16px;line-height:1.5;margin-top:18px}
.pst .goal-motive span{margin-bottom:6px}
.pst .goal-figures{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin:0;align-self:end}
.pst .goal-figures>div{border-top:2px solid var(--ink);padding-top:14px}
.pst .goal-figures dd{margin:10px 0 0}
.pst .goal-figures strong{display:block;font-size:32px;line-height:1.08;font-weight:600;letter-spacing:-.04em}
.pst .goal-figures dd span{display:block;font-size:13px;line-height:1.5;color:var(--muted);margin-top:6px}
.pst .risk-axis{border-radius:14px}
.pst .risk-axis h3{font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--muted)}
.pst .risk-axis .axis-value{font-size:22px;font-weight:500}
.pst .risk-segments{gap:4px;margin:22px 0 14px}
.pst .risk-segments .segment-mark{height:10px;border-radius:5px;background:var(--track);margin-bottom:9px}
.pst .risk-segments .chosen .segment-mark{background:var(--mark);box-shadow:0 0 0 3px rgba(203,234,82,.6)}
.pst .risk-segments .chosen .segment-mark:after{display:none}
.pst .risk-segments .in-range .segment-mark{background:var(--mark-soft)}
.pst .risk-segments .chosen{color:var(--ink)}
.pst .axis-note{font-size:13px;line-height:1.6;color:#4b5144;margin-bottom:6px}
.pst .skill-grid{list-style:none;padding:0;margin:0;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}
.pst .skill-grid li{display:grid;grid-template-columns:24px minmax(0,1fr);gap:3px 12px;align-items:start;background:#fff;border:1px solid var(--line);border-radius:12px;padding:16px}
.pst .skill-grid li.is-done{background:#fafcf3;border-color:#d5e0b8}
.pst .skill-mark{display:block;width:24px;height:24px;grid-row:1/3}
.pst .skill-name{font-size:14px;font-weight:600;line-height:1.3}
.pst .skill-state{font-size:12px;color:var(--muted)}
.pst .is-done .skill-state{color:var(--accent-deep)}
.pst .chart-chips{list-style:none;padding:0;margin:14px 0 0;display:flex;flex-wrap:wrap;gap:8px}
.pst .chart-chips li{display:inline-flex;align-items:center;gap:8px;font-size:14px;line-height:1.3;border:1px solid var(--line);border-radius:999px;padding:9px 14px;color:var(--muted)}
.pst .chart-chips li.is-on{background:#eef5d6;border-color:#d5e0b8;color:#2f3d0c;font-weight:600}
.pst .chart-chips li.is-on:before{content:'';width:8px;height:8px;border-radius:50%;background:var(--mark)}
.pst .chart-limits{font-size:15px;margin-top:20px;border-top:1px solid var(--line);padding-top:16px}
.pst .chart-limits span{margin-bottom:6px}
.pst .profile-meaning{margin-top:52px}
.pst .profile-meaning>h2{font-size:27px;margin-bottom:20px}
.pst .profile-narrative h3{font-size:22px;line-height:1.25;letter-spacing:-.03em;margin-bottom:14px}
.pst .profile-consequences{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;margin:28px 0}
.pst .profile-consequences .loss-boundary{margin:0;padding:27px;background:#fff;border:1px solid var(--line);border-radius:8px}
.pst .profile-consequences .capacity-card{margin:0;border-radius:8px}
.pst .profile-consequences .eyebrow{font-size:11px;color:var(--accent-deep)}
.pst .profile-consequences h2{font-size:24px;line-height:1.25;margin:12px 0}
.pst .profile-consequences p:not(.eyebrow){font-size:15px;line-height:1.7}
@media(max-width:1000px){
.pst .skill-grid{grid-template-columns:repeat(2,minmax(0,1fr))}
.pst .chart-hero{grid-template-columns:1fr;grid-template-areas:"head" "figure" "key";gap:20px}
.pst .chart-hero-figure{max-width:520px;width:100%;justify-self:center}
}
@media(max-width:900px){
.pst .strategy-summary,.pst .chart-pair,.pst .profile-consequences,.pst .chart-goal{grid-template-columns:1fr}
.pst .chart-goal>.chart-scale-ends{margin-top:-14px}
}
@media(max-width:600px){
.pst .strategy-hero{padding:28px 22px 30px;border-radius:14px}
.pst .strategy-hero:after{right:-110px;top:-110px;box-shadow:0 0 0 30px rgba(203,234,82,.03)}
.pst .profile-narrative h3{font-size:20px}
.pst .strategy-name{font-size:clamp(40px,12.5vw,56px);margin-top:20px}
.pst .strategy-name:after{margin-top:20px;width:56px;height:5px}
.pst .strategy-what{font-size:17px;margin-top:16px}
.pst .strategy-why,.pst .strategy-route{padding:22px 20px}
.pst .strategy-why li p,.pst .strategy-route p{font-size:16px}
.pst .strategy-route .btn{width:100%}
.pst .strategy-highlight{padding:18px 20px}
.pst .funding-step{padding-left:34px;padding-bottom:30px}
.pst .funding-step:before{left:7px}
.pst .funding-step:after{left:0}
.pst .funding-step-head h2{font-size:24px}
.pst .funding-options .funding-card{padding:20px}
.pst .funding-options .funding-card h3{font-size:20px}
.pst .funding-notes{padding:20px}
.pst .chart-block{margin-top:36px}
.pst .chart-block>h2,.pst .chart-block .section-title h2,.pst .profile-meaning>h2{font-size:24px}
.pst .chart-hero{padding:24px 18px;border-radius:14px}
.pst .chart-hero-head h2{font-size:34px}
.pst .chart-card,.pst .chart-goal{padding:22px 20px}
.pst .chart-goal{gap:20px}
.pst .goal-main h2{font-size:28px}
.pst .goal-figures strong{font-size:26px}
.pst .chart-value{font-size:19px}
.pst .chart-scale.is-long{grid-template-columns:1fr;gap:7px}
.pst .chart-scale.is-long li{display:flex;align-items:center;gap:12px;font-size:13px}
.pst .chart-scale.is-long .chart-scale-bar{flex:0 0 46px;margin:0}
.pst .skill-grid li{padding:14px 12px;gap:3px 10px}
.pst .skill-name{font-size:13px}
.pst .radar-key-answer{font-size:14px}
}
@media(max-width:360px){
.pst .skill-grid{grid-template-columns:1fr}
.pst .goal-figures{grid-template-columns:1fr}
.pst .chart-scale li{font-size:10px}
}
/* Report 0.28: the keep-report buttons sit apart, side by side or stacked on phones. */
.pst .keep-report>div:last-child{display:flex;flex-wrap:wrap;gap:12px;align-content:start;align-items:flex-start;align-self:center}
/* An odd last card takes the full row, so no empty cell sits beside it. */
.pst .profile-narrative article:last-child:nth-child(odd),.pst .strategy-compare:last-child:nth-child(odd){grid-column:1/-1}
/* One hairline, not two: no rule under the last section before the page buttons or the end of a chapter. */
.pst .detail-section:has(+.report-pagination),.pst .full-report-chapter>.detail-section:last-child{border-bottom:0}
/* The full report's heading: its buttons (chapter by chapter, Download PDF) sit in one row under the title. */
.pst .full-report-heading{display:flex;flex-wrap:wrap;align-items:center;gap:10px 24px}
.pst .full-report-heading>:is(.eyebrow,h1,h2,p){flex:0 0 100%}
.pst .full-report-heading>h1{margin:8px 0;max-width:none}
@media(max-width:700px){
.pst .keep-report>div:last-child{flex-direction:column;align-items:stretch}
}

/* The tool fills the screen with its own page, like the register page (no hub header or footer). Behind it, the
   page itself is the prototype's paper (body's background there), not the hub's white, for overscroll on a phone. */
.pst{min-height:100vh}
html:has(.pst),html:has(.pst)>body{background:#f4f5ef}
/* The hub's global rules (styles/base.css) that the prototype never had, undone inside the tool so it looks as
   approved: pseudo-elements keep the browser's content-box sizing, and the hub's shared .btn height and nowrap
   don't reach the tool's own .btn. */
.pst *::before,.pst *::after{box-sizing:content-box}
.pst .btn{height:auto;white-space:normal}
/* Printing: when the tool is on the page, nothing of the hub prints with it. The result screen prints only the
   designed report (above); its A4 @page rule is a constructed sheet the tool adds while the report shows. */
@media print{
html:has(.pst)>body{background:#fff!important;height:auto!important;overflow:visible!important;margin:0!important}
body:has(.pst)>:not(:has(.pst)),:has(>.pst)>:not(.pst){display:none!important}
.pst{min-height:0!important}
}

/* Stage 2 (docs/property-strategy-spec.md S2.8): the email step, in the tool's own look, and the report's ending. */
.pst .email-step{max-width:560px}
.pst .email-step h1{margin:14px 0 28px}
.pst .email-field{display:grid;gap:8px;margin-bottom:18px}
.pst .email-field label{font-size:13px;font-weight:600}
.pst .email-input{width:100%;min-height:52px;padding:12px 16px;border:1px solid var(--line);border-radius:7px;background:#fff;font:inherit;font-size:16px;color:inherit}
.pst .email-input:focus{outline:2px solid var(--ink);outline-offset:2px}
.pst .pst-hp{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}
.pst .email-step .btn{margin-top:14px}
.pst .email-account,.pst .email-consent{font-size:13px;color:var(--muted);margin-top:18px;line-height:1.6}
.pst .email-consent a{color:inherit;text-decoration:underline}
/* The box to opt out of Adam's emails (29 Oct 2026), under the line about them and before the button: a native checkbox
   with its label, the hub's way (accent-color), reached by Tab, its focus ring the tool's own (.pst input:focus-visible). */
.pst .email-optout{display:flex;align-items:center;gap:10px;margin-top:6px}
.pst .email-optout input{width:20px;height:20px;flex:0 0 20px;margin:0;accent-color:var(--accent-deep);cursor:pointer}
.pst .email-optout label{font-size:14px;padding:8px 0;cursor:pointer}
.pst .report-ending{background:#fff;border:1px solid var(--line);padding:24px 30px;border-radius:10px;margin-top:16px}
.pst .report-ending[hidden]{display:none}
.pst .report-ending-line{font-size:18px;font-weight:600;margin:0 0 8px}
.pst .report-ending-next{font-size:13px;color:var(--muted);margin:0}
.pst .report-ending-next a{color:inherit;text-decoration:underline}
.pst .worksheet-button{margin-top:18px}
.pst .strategy-saved-page{max-width:560px}
.pst .strategy-saved-page h1{margin:14px 0 18px}
.pst .strategy-saved-page p{color:var(--muted);margin-bottom:24px}
@media (max-width:640px){.pst .email-step .btn{width:100%}.pst .report-ending{padding:22px 24px}}
